
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M24 0H0v24h24z"}}),_c('path',{staticClass:"gst-svg-icon",attrs:{"d":"M12 4a8 8 0 110 16 8 8 0 010-16zm2.257 5.282l-3.611 3.396-.903-.849a1.07 1.07 0 00-1.444 0 .921.921 0 000 1.36l1.625 1.529a1.065 1.065 0 001.444 0l4.333-4.077a.921.921 0 000-1.359 1.065 1.065 0 00-1.444 0z","fill":"#23262D"}})])])
          )
        }
      }
    